import { render, staticRenderFns } from "./crudInformation.vue?vue&type=template&id=ab121176&"
import script from "./crudInformation.vue?vue&type=script&lang=js&"
export * from "./crudInformation.vue?vue&type=script&lang=js&"
import style0 from "./crudInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports